import React from "react";

import { Checkbox } from "components/Checkbox";

import { ContainerCheckBox, Title } from "./style";

interface Props {
  value: boolean;
  onChange: (newValue: boolean) => void;
  label?: string;
  style?: React.CSSProperties;
}

export function CheckBoxConfidential({ value, onChange, label, style }: Props) {
  const handleToggle = () => {
    onChange(!value);
  };

  return (
    <ContainerCheckBox>
      <Checkbox id="confidential" checked={value} onChange={handleToggle} />
      <Title>{label}</Title>
    </ContainerCheckBox>
  );
}
